export default {
  fields: [{
      name: 'renting_preparation_id',
      label: "Préparation",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'renting_preparation',
      label: "Préparation",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.renting_number : null
    },
    {
      name: 'product_id',
      label: "Produit",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'product',
      label: "Produit",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      detailLink: 'ProductDetail',
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'product_selling',
      label: "Produit à la vente",
    },
    {
      name: 'product_renting',
      label: "Produit à la location",
    },
    {
      name: 'quantity',
      label: "Quantité",
      type: 'number',
      inForm: false,
      required: false,
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'prepared',
      label: "Préparé",
      type: 'yesno',
      inForm: false,
      required: false,
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'created_at',
      label: "Date de création",
      type: 'date',
      inForm: false,
      inList: true,
      sortable: true,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("DD-MM-YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'stock',
      label: "Stock réel",
    },
    {
      name: 'buffer_stock',
      label: "Stock virtuel",
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/RentingPreparationProduct/config.js